module.exports = __webpack_public_path__ + "img/professionalRefurbishment.4faff19.jpg";